import React, { FC, useRef } from 'react';
import { useOrganizationQuery } from '../../../api/queries/use-organization-query';
import { Driver } from '../../../types';
import { OrgQueryKeys } from '../../../api/config';
import { useLoadEditableItems } from '../hooks/use-load-editable-items';
import { EditableLoadDriver } from '../drafts-loads-table-cells/loads/editable/editable-load-driver';
import { EditableLoadTractor } from '../drafts-loads-table-cells/loads/editable/editable-load-tractor';
import { EditableLoadTrailer } from '../drafts-loads-table-cells/loads/editable/editable-load-trailer';
import { HereMap, HereMapRefObject } from '../../here-maps/here-map';
import { Load } from '../../../types';
import { L } from 'harmony-language';
import { LoadStopTime } from '../drafts-loads-table-cells/loads/display/load-stop-time';
import { EstimatedTotalTrip } from '../drafts-loads-table-cells/loads/display/estimated-total-trip';
import { ResourceSchedulingButton } from '../drafts/scheduling/resource-scheduling-button';
import { HereMapOrderContent } from '../loads/edit-create-order/here-map-order-content';

interface EditCreateLoadTopProps {
    editedLoad: Load;
}

export const EditCreateLoadTop: FC<EditCreateLoadTopProps> = (props) => {
    const { editedLoad } = props;
    const { data: drivers = [] } = useOrganizationQuery<Driver[]>(OrgQueryKeys.drivers);
    const loadEditableItems = useLoadEditableItems();
    const mapRef = useRef<HereMapRefObject>(null);

    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: '1fr 2fr',
                gridColumnGap: '1rem',
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
                {editedLoad.id && (
                    <div style={{ display: 'flex', columnGap: '.3rem' }}>
                        <div>#{editedLoad.id}</div>
                    </div>
                )}
                <div style={{ display: 'flex', columnGap: '.3rem' }}>
                    <span>{L.date()}:</span>
                    <div><LoadStopTime time={editedLoad.date} /></div>
                </div>
                <div style={{ display: 'flex', columnGap: '.3rem' }}>
                    <span>{L.estimatedTotalTripTime()}:</span>
                    <EstimatedTotalTrip mode='time' load={editedLoad} />
                </div>
                <div>
                    <ResourceSchedulingButton loadEditableItems={loadEditableItems} />
                </div>
                <EditableLoadDriver
                    drivers={drivers}
                    getDriverProperties={loadEditableItems.getDriverProperties}
                />
                <EditableLoadTractor
                    getTractorProperties={loadEditableItems.getTractorProperties}
                />
                <EditableLoadTrailer
                    getTrailerProperties={loadEditableItems.getTrailerProperties}
                />
            </div>
            <div style={{ border: '1px solid #ccc', height: '100%', minHeight: '40vh' }}>
                <HereMap ref={mapRef}>
                    <HereMapOrderContent mapRef={mapRef} />
                </HereMap>
            </div>
        </div>
    );
};
